import { checkParams, zeroUnit } from '../../utils'
import { formatTime, formatDate } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let arr = []
	const info = injured.injured || ''

	if (this.isResurvey) {
		arr.push({
			label: '伤者是否在医院',
			value:
				setting.independentMap[injured.injured && injured.injured.inHospital],
		})
		if (this.isResurveyNotInHospital) {
			arr.push({
				label: '伤者去处',
				value: injured.injured && injured.injured.goPlace,
			})
		}
	}
	if (!this.isResurveyNotInHospital) {
		arr.push({
			label: '证件类型',
			value: setting.idTypeMap[injured.injured && injured.injured.idType],
		})
		arr.push({
			label: '证件号',
			value: injured.injured && injured.injured.idNo,
		})
	}
	arr.push({
		label: '姓名',
		value: injured.injured && injured.injured.name,
	})
	if (!this.isResurveyNotInHospital) {
		arr = arr.concat([
			{
				label: '性别',
				value: setting.sexMap[injured.injured && injured.injured.sex],
			},
			{
				label: '年龄',
				value: zeroUnit(injured.injured && injured.injured.age, '岁'),
			},
			{
				label: '出生日期',
				value: formatDate(injured.injured && injured.injured.birthday),
			},
			{
				label: '户籍地址',
				value: injured.injured && injured.injured.censusRegisterAddress,
			},
			{
				label: '户籍性质',
				value:
					setting.censusRegisterTypeMap[
						injured.injured && injured.injured.censusRegisterType
					],
			},
		])
	}
	arr.push({
		label: '伤者电话',
		value: injured.injured && injured.injured.selfPhone,
	})
	if (injured.injured && injured.injured.phone) {
		const phone = injured.injured.phone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '家属电话',
				value: phone[0],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `家属电话${index + 1}`,
					value: item,
				})
			}
		}
	} else {
		arr.push({
			label: '家属电话',
			value: '',
		})
	}

	arr.push(
		{
			label: '伤者紧急联系人姓名',
			value: injured.injured && injured.injured.emergencyName,
		},
		{
			label: '紧急联系人与伤者关系',
			value:
				setting.emergencyTypeMap[
					injured.injured && injured.injured.relationShip
				],
		}
	)

	if (injured.injured && injured.injured.emergencyPhone) {
		const phone = injured.injured.emergencyPhone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '紧急联系人电话',
				value: phone[0],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `紧急联系人电话${index + 1}`,
					value: item,
				})
			}
		}
	} else {
		arr.push({
			label: '紧急联系人电话',
			value: '',
		})
	}

	const isTargetType = this.isFirstVisit || this.isResurveyInHospital
	if (isTargetType && !this.isCarInsurance && !this.isPAIC) {
		arr = arr.concat([
			{
				label: '入院是否使用医保报销途径',
				value: setting.yesNoMap[info.medicalInsurance],
				key: 'medicalInsurance',
			},
			{
				label: '有无购买其他保险',
				// value: setting.haveNoneMap[injured.injured.otherInsurance],
				value:
					info.otherInsurance === '1'
						? info.otherInsuranceDesc
						: setting.haveNoneMap[info.otherInsurance],
				key: 'otherInsurance',
			},
		])
	}

	return {
		title: '伤者信息',
		children: arr,
	}
}
